import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { SpecialProjectCheck } from 'src/app/shared/services/common/special-project-check';

import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'code-check-modal',
  templateUrl: './code-check-modal.component.html',
  styleUrls: ['./code-check-modal.component.scss']
})
export class CodeCheckModalComponent implements OnInit {
  private emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  public codeForm: any = this.fb.group({
    code: ['', [Validators.required, Validators.minLength(4)]],
    email: [null, [Validators.required, Validators.email, Validators.pattern(this.emailPattern), Validators.minLength(4)]]
  });
  private hideEvent: EventEmitter<boolean> = new EventEmitter();
  private zambiaCodeEvent: EventEmitter<object> = new EventEmitter();
  public projectCode: string = '';

  constructor(
    private fb: UntypedFormBuilder,
    public bsModalRef: BsModalRef,
    public globalConstants: GlobalConstants,
    private specialProjectCheck: SpecialProjectCheck
  ) { }

  ngOnInit(): void {
      this.projectCode = this.specialProjectCheck.checkProject().code;
  }

  hideModal() {
    this.hideEvent.emit(true);
  }

  public codeFormSubmit(): void {
    if (this.codeForm.valid)
    this.zambiaCodeEvent.emit({
      payload: {
          code: this.codeForm.get('code').value,
          recipient_details: { 
            email: this.codeForm.get('email').value
          }
      }
    });
  }

}
